module.exports = __webpack_public_path__ + "img/random-welcome.png";